import Box from '@mui/material/Box'
import config from '../../config'
import { Typography } from '@mui/material'
import { useParams } from 'react-router'
import Link from '@material-ui/core/Link'
import { Link as RouterLink } from 'react-router-dom'
import { useMemo } from 'react'

export const LetterSendingResponse = () => {
  const { is_success } = useParams()
  const isSuccess = useMemo(
    () => (is_success === 'true' ? true : false),
    [is_success]
  )

  return (
    <Box
      elevation={2}
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 4,
      }}
    >
      <img
        style={{
          width: '200px',
          marginBottom: '30px',
        }}
        src={`${config.PUBLIC_URL}/img/icons/icon-mail-color.svg`}
      />
      {isSuccess ? (
        <Typography variant="h4" color="success.main" align="center">
          Le courrier a bien été envoyé
        </Typography>
      ) : (
        <Typography color="error.main" align="center">
          Erreur lors de l'envoi du courrier, veuillez contacter l'équipe
          support
        </Typography>
      )}
      <Link component={RouterLink} to="/send-letter" variant="h6">
        Envoyer un nouveau courrier
      </Link>
    </Box>
  )
}
